import classnames from 'classnames';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory from 'react-bootstrap-table2-filter';
import { toast } from 'react-toastify';
import { Alert, Button, ButtonGroup, Col, Input, Row } from 'reactstrap';
import NumberMaskForm from '../../../components/numberMaskForm';
import ProvisionList from '../../../components/ProvisionList';
import OrderHistoryList from '../../../components/OrderHistoryList';

export default function NewNumber(props) {
  const {
    activeNumberTab,
    selectRow,
    searchedNumbers,
    clearSearchedNumbers,
    resetSelectedNumbers,
    columns,
    gateways,
    filterEmails,
    toggleTab,
    state,
    searchNumber,
    companies,
    selectedNumbers,
    companySearchFilter,
    onToggleChange,
    onOrder,
    setProvider,
    provider,
    numberCarrierChangeAccess,
  } = props;

  const isReadOnly = numberCarrierChangeAccess === 'read';

  return (
    <Row>
      <Col md={12}>
        <div>
          <Row>
            <Col lg={10}>
              <ButtonGroup className="tab-group">
                {!isReadOnly && (
                  <>
                    <Button
                      className={classnames({
                        active: activeNumberTab === 'search',
                      })}
                      onClick={() => toggleTab('search')}
                    >
                      Search
                    </Button>
                    <Button
                      className={classnames({
                        active: activeNumberTab === 'provisioning',
                      })}
                      onClick={() => {
                        selectedNumbers.length
                          ? toggleTab('provisioning')
                          : toast.error('No number selected');
                      }}
                    >
                      Provision
                    </Button>
                  </>
                )}
                <Button
                  className={classnames({
                    active: activeNumberTab === 'Order History',
                  })}
                  onClick={() => {
                    toggleTab('Order History')
                  }}
                >
                  Order History
                </Button>
              </ButtonGroup>
            </Col>
            {/* <Col>
              <Input
                type="select"
                value={provider}
                style={{ marginRight: '0', color: '#6c757d', background: '#f0f3f7' }}
                onChange={e => setProvider(e.currentTarget.value)}
              >
                <option value={'VoiceTel'}>VoiceTel</option>
                <option value={'Inteliquent'}>Inteliquent</option>
              </Input>
            </Col> */}
          </Row>
          {
            {
            'search':
                      <Row>
                        <Col md={3} sm={12}>
                          <NumberMaskForm states={state.states} searchNumber={searchNumber} clearSearchedNumbers={clearSearchedNumbers} resetSelectedNumbers={resetSelectedNumbers}/>
                        </Col>
                        <Col md={9} sm={12}>
                          <div className="search-content">
                            <BootstrapTable
                              selectRow={selectRow}
                              keyField="telephoneNumber"
                              data={searchedNumbers.tnResult}
                              columns={columns}
                              filter={filterFactory()}
                            />
                            {searchedNumbers.tnResult.length === 0 ? (
                              <Alert rowSpan={12} color="info">
                                No Number Searched
                              </Alert>
                            ) : null}
                          </div>
                        </Col>
                      </Row>,
           'provisioning': 
                      <div>
                        <ProvisionList
                          orderedNumbers={state.orderedNumbers}
                          companies={companies.docs}
                          numbers={selectedNumbers}
                          gateways={gateways}
                          filterEmails={filterEmails}
                          companySearchFilter={companySearchFilter}
                          onToggleChange={onToggleChange}
                          sameForAll={state.sameForAll}
                          onOrder={onOrder}
                          provider={provider}
                          setProvider={setProvider}
                        />
                      </div>,
            'Order History': <div> <OrderHistoryList/> </div>,
            }[isReadOnly ? 'Order History' : activeNumberTab]
          }
        </div>
      </Col>
    </Row>
  );
}
